const RFIDType = {
  Autosweep: "autosweep",
  Easytrip: "easytrip",
};

export default RFIDType;
